export const CONTENT_WIDTH = 680;
export const FILTER_QUERY_DETAILS_TABLE_WIDTH = 652;

export const ISSUE_RANKING_MODAL_TEST_ID =
	'software-board-settings-general-filter-settings.ui.board-filter-details.issue-ranking.confirmation-modal.issue-ranking-confirmation-modal';
